import { put, retry, takeEvery } from 'redux-saga/effects';
import ActionTypes from '../../../../Data/ActionTypes';
import isDomainInternalQuery from './isDomainInternalQuery';

/**
 * Worker - requested by below function and carries out any async work
 */
export function* worker(action) {
  const { domain } = action.payload;

  if (!domain) {
    return;
  }

  try {
    const requestArguments = {
      isDomainInternal: {
        domain,
      },
    };

    const args = {
      variables: requestArguments,
    };

    const isDomainInternal = yield retry(
      3, // retry 3 times
      2000, // wait 1 second between retries
      isDomainInternalQuery,
      args
    );

    yield put({
      type: 'FORM_CONFIG/setIsDomainInternal',
      payload: isDomainInternal,
    });
  } catch (error) {
    yield put({
      type: 'FORM_CONFIG/setIsDomainInternal',
      payload: null,
    });
  }
}

/**
 * Redux Watcher
 */
export default function* isDomainInternalWatcher() {
  yield takeEvery(ActionTypes.IS_DOMAIN_INTERNAL, worker);
}
